/** @jsx h */
const Checkbox = ({ option, filterName, handleChange, pluginNamespace }) => {
  return (
    <li>
      <label
        className={`search-section__checkbox  ${
          option.selected ? 'search-section__checkbox--is-active' : ''
        } btn btn--tertiary btn--negative`}
        htmlFor={`${filterName}-${option.value}`}
      >
        <input
          id={`${filterName}-${option.value}`}
          className="sr-only"
          type="checkbox"
          name={`${pluginNamespace}[filter][]`}
          value={`${filterName}:${option.value}`}
          onChange={handleChange}
          checked={option.selected}
        />

        <span>{option.label}</span>
      </label>
    </li>
  );
};

export default Checkbox;
